import { DataBean } from "../DataBean";

export class ManufacturingStardard extends DataBean {

    public async getManufacturingStardardByCode(regexStr: string, idProductiveProcessType: number, idProduct: number, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getManufacturingStardardByCode_String_Number_Number_Number_Number", [regexStr, idProductiveProcessType, idProduct, page, recordsPerPage]);
    }

    public async getManufacturingStardardByID(idManufacturingStardard: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.productionorders.ManufacturingStardard_getManufacturingStardard_Number", [idManufacturingStardard]);
    }

    public async getManufacturingStardardByProduct(idProduct: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getManufacturingStardardByProduct_Number", [idProduct]);
    }

}
